import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { MapPin, Eye, ArrowRight } from "lucide-react";
import { mockData } from "../mock";

const CertifiedDirectorySection = () => {
  const { certifiedDirectory } = mockData;

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto text-center">
          {/* Clean Header - Welcome.com Style */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Certified Business
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-600"> 
              {" "}Directory
            </span>
          </h2>
          
          {/* Professional Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed font-medium">
            Connect with verified sustainable organizations across industries and regions worldwide
          </p>
          
          <div className="w-24 h-1 bg-gradient-to-r from-indigo-500 to-blue-500 mx-auto rounded-full mb-16"></div>

          {/* Stats Section */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mb-16">
            {[
              { number: "500+", label: "Certified Organizations" },
              { number: "50+", label: "Industry Sectors" },
              { number: "30+", label: "Global Markets" },
              { number: "3", label: "Excellence Tiers" }
            ].map((stat, index) => (
              <Card key={index} className="text-center p-6 border-0 bg-white hover:shadow-md transition-shadow duration-300">
                <CardContent className="p-0">
                  <div className="text-3xl font-bold text-indigo-600 mb-2">{stat.number}</div>
                  <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
            {/* Browse Directory Card */}
            <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-white p-8">
              <CardContent className="p-0">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 to-indigo-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="h-8 w-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Explore Directory
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Discover certified sustainable businesses worldwide. Filter by industry, certification tier, and geographical region to find your ideal partners.
                </p>

                <a href="/directory">
                  <Button 
                    className="bg-gradient-to-r from-indigo-500 to-indigo-600 text-white hover:from-indigo-600 hover:to-indigo-700 transition-all duration-300 font-semibold"
                  >
                    Browse Directory
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </CardContent>
            </Card>

            {/* Get Listed Card */}
            <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-white p-8">
              <CardContent className="p-0">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Eye className="h-8 w-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Get Listed
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Showcase your sustainability achievements to a global network of conscious businesses. Gain visibility and attract aligned partners.
                </p>

                <a href="/signup">
                  <Button 
                    variant="outline" 
                    className="border-blue-300 text-blue-600 hover:bg-blue-50 transition-all duration-300 font-semibold"
                  >
                    Join Directory
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Clean CTA Section */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Connect with Purpose-Driven Organizations
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed max-w-3xl mx-auto">
              Join a global network of certified sustainable businesses. Find partners, suppliers, and collaborators who share your values.
            </p>
            <a href="/directory">
              <Button 
                size="lg"
                className="bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Explore Network
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertifiedDirectorySection;